(function () {
    const originalBottom = '20px';
    const accessibilityIconPosition = function () {
        const scrollPosition = document.documentElement.scrollTop;
        const aioaButton = document.querySelector('#aioa-trigger-button button');
        if (aioaButton.length === 0) {
            return;
        }

        const scrollFromBottom = document.documentElement.scrollHeight - window.innerHeight - scrollPosition;

        if (scrollFromBottom <= 40) {
            aioaButton.style.bottom = '80px';
        } else {
            aioaButton.style.bottom = originalBottom;
        }
    }
    window.addEventListener('scroll', accessibilityIconPosition);
})();
